import React from 'react';
import './loading.css'; // Importando o arquivo de estilos
import logo from "./assets/logo-basel.png"
const Loader = ({ imageSrc, text }) => {

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {/* O anel que vai girar */}
        <div className="loader-spinner"></div>

        {/* A imagem centralizada */}
        <div style={{ zIndex: 2 }}>
          <div style={{
            textAlign: 'center',
            verticalAlign: 'middle',
            backgroundColor: "black",
            padding: "10px",
            color: "white",
            borderRadius: "5px",
          }}>{text || 'Carregando..................'}</div>

          <img
            src={imageSrc || logo}
            alt="Carregando..."
            className="loader-image"
          /></div>
      </div>
    </div>
  );

}
export default Loader;